import { defineComponent as _defineComponent } from 'vue'
import { h, computed, reactive, defineAsyncComponent, onMounted, ref, watch } from 'vue'
import { VueFinalModal } from 'vue-final-modal'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { mainSearchesResource } from '@/services/general.service'
import { useCancelableRequest } from '@/composables/useCancelableRequest'
import { useUserCityStore } from '@app/localization/cities/store'
import { useOptionsGetterForFields } from '@/composables/useOptionsGetter'
import { GEO_CITIES_LIST_URL } from '@/services/geo.service'
import useField from '@/composables/useField'
import { clone } from 'ramda'
import { useSubmit } from '@/composables/useSubmit'

const MIN_LENGTH_TO_SEARCH = 4

enum SearchCategory {
  doctor = 'choose_doctor',
  medical = 'choose_medical',
}

export default /*@__PURE__*/_defineComponent({
  __name: 'General',
  props: {
    currentCity: {}
  },
  setup(__props: any, { expose: __expose }) {

const SearchResultDoctor = defineAsyncComponent(
  () => import('./SearchResultDoctor.vue')
)
const SearchResultMedical = defineAsyncComponent(
  () => import('./SearchResultMedical.vue')
)

const { t } = useI18n()

const props = __props

const inputRef = ref(null)

const { load, result } = useCancelableRequest(
  mainSearchesResource,
  responseTransform
)
const defaultCategory = { id: SearchCategory.doctor, title: t('Choose doctor') }

const categoriesList = [
  defaultCategory,
  { id: SearchCategory.medical, title: t('Choose medical') },
]

const FIELDS = ref([
  useField('city', '', {
    rules: 'required',
    component: 'd-control-multiselect',
    options: [],
    labelBy: 'title',
    classes: 'main-search__item--first with-line',
    pagination: {},
    loading: false,
    internalSearch: false,
    searchable: true,
    multiple: false,
    trackBy: 'slug',
    'allow-empty': false,
    closeOnSelect: true,
    events: {
      open: async (val) =>
        await useOptionsGetterForFields(
          GEO_CITIES_LIST_URL,
          val,
          'city',
          null,
          FIELDS.value
        ),
      'search-change': async (val) =>
        await useOptionsGetterForFields(
          GEO_CITIES_LIST_URL,
          val,
          'city',
          null,
          FIELDS.value
        ),
      afterList: async (val) =>
        await useOptionsGetterForFields(
          GEO_CITIES_LIST_URL,
          '',
          'city',
          val,
          FIELDS.value
        ),
    },
  }),
  useField('category', '', {
    rules: 'required',
    component: 'd-control-multiselect',
    options: categoriesList,
    labelBy: 'title',
    classes: 'main-search__item--fixed with-line',
    pagination: {},
    loading: false,
    internalSearch: false,
    searchable: false,
    multiple: false,
    trackBy: 'id',
    'allow-empty': false,
    closeOnSelect: true,
    events: {
      close: () => {
        if (form.value.query?.length >= MIN_LENGTH_TO_SEARCH) {
          if (isDesktop.value) {
            submit()
          }
        }
      },
    },
  }),
  useField('query', '', {
    placeholder: t('Enter text to search for'),
    classes: 'growest',
  }),
])
const userCityStore = useUserCityStore()
const { selectedCity } = storeToRefs(userCityStore)

const form = ref({
  city: selectedCity.value || props.currentCity,
  category: defaultCategory,
  query: '',
})

watch(
  () => form.value.city,
  (newVal) => {
    if (newVal?.id) {
      userCityStore.setCity(newVal)
    }
    if (form.value.query?.length >= MIN_LENGTH_TO_SEARCH) {
      if (isDesktop.value) {
        submit()
      }
    }
  }
)
watch(
  () => form.value.query,
  (newVal) => {
    if (newVal?.length >= MIN_LENGTH_TO_SEARCH) {
      if (isDesktop.value) {
        submit()
      }
    }
  }
)

watch(selectedCity, (newCity) => {
  if (newCity?.slug !== form.value.city?.slug) {
    form.value.city = newCity
  }
})

const isShow = ref(true)

function responseTransform({ item }) {
  isShow.value = true
  return item
}

const formRef = ref(null)

const submit = (isSubmitClick?: boolean) => {
  if (form.value.query.length >= MIN_LENGTH_TO_SEARCH) {
    const data = clone(form.value)
    data.city = form.value.city.slug
    data.category = form.value.category.id
    return useSubmit(load({}, data), formRef.value).then(() => {

      if (!isDesktop.value && isSubmitClick) {
        openResultModal()
      }
    })
  }
}

const isOpen = ref(false)

function openResultModal() {
  isOpen.value = true
}

const isDesktop = ref(true)
function checkWidth() {
  isDesktop.value = window.innerWidth >= 1200
}
onMounted(() => {
  checkWidth()
})

function focunInput() {

  const [input=null] = inputRef.value[0].getElementsByTagName('input')
  input?.focus?.()
}
__expose({
  focus: focunInput,
})
function formatOption(obj: {
  region: { title: string } | null
  subregion: { title: string } | null
  country: { title: string }
}) {
  const parts = []
  if (obj.subregion?.title) {
    parts.push(obj.subregion.title)
  }
  if (obj.region?.title) {
    parts.push(obj.region.title)
  }
  if (obj.country?.title) {
    parts.push(obj.country.title)
  }
  return parts.filter(Boolean).join(', ')
}

const __returned__ = { SearchResultDoctor, SearchResultMedical, MIN_LENGTH_TO_SEARCH, t, props, inputRef, load, result, SearchCategory, defaultCategory, categoriesList, FIELDS, userCityStore, selectedCity, form, isShow, responseTransform, formRef, submit, isOpen, openResultModal, isDesktop, checkWidth, focunInput, formatOption, h, computed, reactive, defineAsyncComponent, onMounted, ref, watch, get VueFinalModal() { return VueFinalModal }, get storeToRefs() { return storeToRefs }, get useI18n() { return useI18n }, get mainSearchesResource() { return mainSearchesResource }, get useCancelableRequest() { return useCancelableRequest }, get useUserCityStore() { return useUserCityStore }, get useOptionsGetterForFields() { return useOptionsGetterForFields }, get GEO_CITIES_LIST_URL() { return GEO_CITIES_LIST_URL }, get useField() { return useField }, get clone() { return clone }, get useSubmit() { return useSubmit } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})